import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.match.js";
import { getCookie } from "./cookies"; // trim方法的polyfill

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  };
} // 统跳前缀


var HTTP_REG = /^(http|\/\/)/;
var ZZ_REG = /^zhuanzhuan:/;
var ZZSELLER_REG = /^zhuanzhuanseller:/;
var CHECK_REG = /^zzcheck/;
var HUNTER_REG = /^(zzhunter|zzhunterwarrior|zzthunder)/;
var ZLJ_REG = /^zljgo/;
var YIGE_REG = /^zzyige/; // 判断一个URL是属于哪种类型地址

export var isHTTPUrl = function isHTTPUrl(path) {
  return HTTP_REG.test(path);
};
export var isZZUrl = function isZZUrl(path) {
  return ZZ_REG.test(path);
};
export var isZZSellerUrl = function isZZSellerUrl(path) {
  return ZZSELLER_REG.test(path);
};
export var isCheckUrl = function isCheckUrl(path) {
  return CHECK_REG.test(path);
};
export var isHunterUrl = function isHunterUrl(path) {
  return HUNTER_REG.test(path);
};
export var isZLJUrl = function isZLJUrl(path) {
  return ZLJ_REG.test(path);
};
export var isYigeUrl = function isYigeUrl(path) {
  return YIGE_REG.test(path);
}; // 兼容zzstore

export var isZZ = /58ZhuanZhuan|zzstore|offlinestorecomplex/gi.test(navigator.userAgent); // 判断是否是安卓

export var isAndroid = function isAndroid() {
  var u = navigator.userAgent;
  var android = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端

  return android;
};

var customUrlHook = function customUrlHook(url) {
  return url;
};

export var setCustomUrlHook = function setCustomUrlHook(f) {
  return customUrlHook = f;
};
export var urlFormatter = function urlFormatter(url, isZZAndroid) {
  if (typeof url === "undefined") return "";
  return _urlHook(_urlFormatter(customUrlHook(url.trim())), isZZAndroid);
};
export var _urlFormatter = function _urlFormatter(url) {
  return /^\/\//.test(url) ? location.protocol + url.substring(url.indexOf("/")) : url;
};
export var getShareMessage = function getShareMessage(options) {
  var title = options.title,
      desc = options.desc,
      content = options.content,
      picPath = options.picPath,
      shareUrl = options.shareUrl,
      imageUrl = options.imageUrl,
      url = options.url,
      link = options.link,
      logParam = options.logParam,
      posterPicPath = options.posterPicPath,
      panelType = options.panelType,
      shareType = options.shareType,
      buttonType = options.buttonType,
      needLogin = options.needLogin,
      twoDimensionCodeX = options.twoDimensionCodeX,
      twoDimensionCodeY = options.twoDimensionCodeY,
      twoDimensionCodeW = options.twoDimensionCodeW,
      twoDimensionCodeColor = options.twoDimensionCodeColor,
      shareParam = options.shareParam;
  var defaultPicUrl = "//img1.zhuanstatic.com/common/img/icon-share.jpg";
  var defaultPosterPicPath = "//img.58cdn.com.cn/ui7/ershou/zzdetail/zz_logo.png";

  var _url = urlFormatter(shareUrl || url || link);

  var _pic = urlFormatter(picPath || imageUrl || defaultPicUrl);

  return Object.assign(options, {
    title: title || "分享",
    desc: desc || content,
    content: content || desc,
    shareUrl: _url,
    url: _url,
    share_url: _url,
    link: _url,
    picPath: _pic,
    image_url: _pic,
    imgUrl: _pic,
    imageUrl: _pic,
    icon: _pic,
    logParam: logParam || "zhuanzhuan",
    posterPicPath: posterPicPath || defaultPosterPicPath,
    panelType: panelType || "allChannel",
    shareType: shareType || "common",
    buttonType: buttonType || "icon",
    needLogin: needLogin || "0",
    twoDimensionCodeX: twoDimensionCodeX || 200,
    twoDimensionCodeY: twoDimensionCodeY || 200,
    twoDimensionCodeW: twoDimensionCodeW || 200,
    twoDimensionCodeColor: twoDimensionCodeColor || "#00ff00",
    shareParam: shareParam || JSON.stringify({
      shareTitle: title || "分享",
      shareContent: content || desc,
      sharePic: _pic
    })
  });
};
export var getDetailUrl = function getDetailUrl(obj) {
  var $customUrl = obj.$customUrl;
  return urlFormatter($customUrl);
};
export var formartChooseAddressRes = function formartChooseAddressRes(res) {
  var _ref = res || {},
      addressJson = _ref.addressJson,
      code = _ref.code,
      phone = _ref.phone,
      addressId = _ref.addressId,
      name = _ref.name,
      address = _ref.address,
      address_book_id = _ref.address_book_id,
      address_mobile_phone = _ref.address_mobile_phone,
      address_name = _ref.address_name,
      address_state = _ref.address_state,
      address_city = _ref.address_city,
      address_county = _ref.address_county,
      address_street = _ref.address_street,
      street_number = _ref.street_number;

  code = "0";
  var detail = address;

  if (!address) {
    detail = "".concat(address_state, " ").concat(address_city, " ").concat(address_county, " ").concat(address_street).concat(street_number);
  }

  addressJson = {
    name: name || address_name,
    mobile: phone || address_mobile_phone,
    id: addressId || address_book_id,
    detail: detail
  };
  return Object.assign({}, _objectSpread({}, res || {}), {
    code: code,
    addressJson: addressJson
  });
};
export var getUrlParams = function getUrlParams(url) {
  url = url || window.location.href;
  if (url.indexOf("?") < 0) return {};
  return url.replace(/^.+?\?/, "").replace(/#.+/, "").split("&").filter(function (param) {
    return param;
  }).map(decodeURIComponent).reduce(function (obj, param) {
    var i = param.indexOf("=");
    var t = [param.slice(0, i), param.slice(i + 1)];
    obj[t[0]] = t[1];
    return obj;
  }, {});
}; // 区别于getUrlParams，解决getUrlParams方法的bug
// getUrlParams中由于先decodeURIComponent，导致了参数中含有=会出现问题

export var getUrlParamsWithoutDecode = function getUrlParamsWithoutDecode(url) {
  url = url || window.location.href;
  if (url.indexOf("?") < 0) return {};
  return url.replace(/^.+?\?/, "").replace(/#.+/, "").split("&").filter(function (param) {
    return param;
  }).reduce(function (obj, param) {
    var i = param.indexOf("=");
    var t = [param.slice(0, i), param.slice(i + 1)];
    obj[t[0]] = t[1];
    return obj;
  }, {});
};
export var getHash = function getHash(url) {
  return ~url.indexOf("#") ? url.replace(/.*#/, "") : "";
};
export var addQuery = function addQuery(url, queryObj) {
  var hash = getHash(url);
  var params = {};
  Object.assign(params, queryObj, getUrlParams(url));
  var newParamStr = Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(params[key]));
  }).join("&");
  return url.replace(/\?.+$/, "").replace(/\#.+$/, "") + (newParamStr && "?" + newParamStr) + (hash && "#" + hash);
};

var _urlHook = function _urlHook(url, isZZAndroid) {
  var params = {};

  if (isZZAndroid) {
    // 安卓 webview 不支持location.replace解决方法
    params = Object.assign({}, {
      isReplaced: 1
    });
  }

  if (!isHTTPUrl(url)) {
    return addQuery(url, params);
  }

  var importantParamArr = ["source", "channel", "use_old_href", "webview", "gjtitle", "suMetric", "metric", "init_from", "hasauth", // 58端授权参数
  "__t"];
  var oldParams = getUrlParams(window.location.href);
  importantParamArr.map(function (key) {
    return oldParams[key] && (params[key] = oldParams[key]);
  });
  return addQuery(url, params);
};

export var addMetricToObj = function addMetricToObj(obj) {
  var metric = obj.metric;
  var newObj = Object.assign({}, obj);

  if (!metric) {
    var params = getUrlParams(window.location.href);

    if (params["metric"]) {
      newObj = Object.assign(newObj, {
        metric: params["metric"]
      });
    }
  }

  return newObj;
};
export var ajaxUrl = function ajaxUrl(url, params) {
  var newUrl = "".concat(url, "?");
  var paramsKeys = Object.keys(params);

  if (paramsKeys.length > 0) {
    paramsKeys.forEach(function (item, index) {
      newUrl = "".concat(newUrl).concat(item, "=").concat(params[item], "&");
    });
  }

  return newUrl;
}; // 判断否是小程序环境

export var isMiniprogram = function isMiniprogram() {
  return (// 微信小程序
    navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === "miniprogram"
  );
}; // 获取PPU，转成对象

export var getPPU = function getPPU() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "PPU";
  var reg = /([^&=]+)=?([^&]*)/g;
  var ppuCookie = getCookie(name) || ""; // cookie ppu有可能是编码过的,需要解码一下

  if (ppuCookie && ~ppuCookie.indexOf("%3D")) {
    ppuCookie = decodeURIComponent(ppuCookie);
  }

  if (!ppuCookie && name.indexOf("UID=") > -1) {
    ppuCookie = name;
  }

  var ppu = {};

  for (var regExe = reg.exec(ppuCookie); regExe !== null; regExe = reg.exec(ppuCookie)) {
    ppu[regExe[1]] = regExe[2];
  }

  return ppu;
}; // 得到主域名地址

export var getDomain = function getDomain(targetUrl) {
  targetUrl = targetUrl || location.href;
  var isM2Domain = document.domain.indexOf("m2.zhuanzhuan.com") !== -1;
  return /58\.com/.test(targetUrl) ? "https://m.zhuanzhuan.58.com" : isM2Domain ? "https://m2.zhuanzhuan.com" : "https://m.zhuanzhuan.com";
}; // 得到任意地址的主域名

export var getDomainFromURL = function getDomainFromURL(url) {
  return url.match(/^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:\.)?([^:\/\n\?\=]+)/im)[1];
};
export var isIphoneX = function isIphoneX() {
  var ua = navigator.userAgent;
  var isIOS = ua.toLocaleUpperCase().indexOf("IPHONE") >= 0;

  if (isIOS && window.screen.height >= 812) {
    return true;
  }

  return false;
}; // M页域名替换
// 检测到当前域名为m2的时候，保持下一步跳转的域名保持一致

export var domainReplacement = function domainReplacement() {
  var originUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var domainReg = /^.*?(m2\.zhuanzhuan\.com)/;
  var domainOriginReg = /^.*?(m\.zhuanzhuan\.com)/;
  var currentDomain = document.domain;

  if (domainReg.test(currentDomain) && domainOriginReg.test(originUrl)) {
    return originUrl.replace("m.zhuanzhuan.com", currentDomain);
  }

  return originUrl;
};
export var guid = function guid() {
  var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";

  for (var i = 32; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }

  return result;
};